<template>
  <div>    
    <MainNavBar />
    <Hero :hero="heroDocuments" />  
    <SectionDocuments /> 
    <!--Section :content="unlimitedUsers" /> 
    <Section :content="accessControl" /> 
    <Section :content="organizeDocs" /--> 
    <CallToAction :content="documentsCTA" /> 
    <GmxFooter /> 
  </div>
</template>

<script>
// @ is an alias to /src
require('@/assets/css/styles.css');
import MainNavBar from '@/components/main-nav-bar.vue';
import Hero from '@/components/hero.vue';
import Section from '@/components/section.vue';
import SectionDocuments from '@/components/section-documents.vue';
import CallToAction from '@/components/call-to-action.vue';
import GmxFooter from '@/components/footer.vue';
export default {
  name: 'Documents',
  components: {
    MainNavBar,
    Hero,
    Section,
    SectionDocuments,
		CallToAction,
    GmxFooter,
  },
  data() {
    return { 
      heroDocuments: { 
        eyebrow: 'A single source for document management and control',
        header: 'Intelligent Document Management and Collaboration',
        subheader: 'Manage and collaborate the content of your files using secure Solid compliant storage.',
        img: 'trinapp_cde.png',
        /*eyebrow: 'Intelligent Document Management and Collaboration',
        header: 'Manage and collaborate on all documents',
        subheader: 'PDF documents are automatically read and stored as Units-of-Thought to your TrinPod\u2122;',*/
        img: 'trinapp_cde.png',
        videoId: '699342008',
        buttons: []
      },
      /*documents: { 
        header: 'TrinPod\u2122',
        headerIcon: 'trinapp_cde.png',
        id: 'documents',
        image: 'trinapp-documents.png',
        colOrderText: 1,
        colOrderImage: 2,
        bgClass: 'bg-light-grad',
        html: 
          '<div>' + 
          ' <p>What it does for you:</p>' + 
          ' <ul>' + 
          '  <li>Manage and collaborate on all documents.</li>' + 
          '  <li>Read PDF documents and store the Units-of-Thought to your TrinPod&trade;.</li>' + 
          ' </ul>' + 
          ' <p>Better than current solutions:</p>' + 
          ' <ul>' + 
          '  <li>Unlimited Free Users and collaborators.</li>' + 
          '  <li>Detailed access control.</li>' + 
          '  <li>Single Master Version.</li>' + 
          '  <li>Organize documents in TrinPods&trade; representing the Business, Building or Project they are related to.</li>' + 
          '  <li>Instantly finding information inside your documents is simple and easy.</li>' + 
          ' </ul>' + 
          '</div>'
      },
      unlimitedUsers: { 
        header: 'Unlimited Free Users and Collaborators',
        headerIcon: '',
        id: 'documents',
        image: 'trinapp-documents.png',
        colOrderText: 1,
        colOrderImage: 2,
        bgClass: 'bg-light-grad',
        html: 
          '<div>' + 
          '  <h5>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua</h5>' + 
          '</div>'
      },
      accessControl: { 
        header: 'Detailed Access Control',
        headerIcon: '',
        id: 'access-control',
        image: 'trinapp-documents.png',
        colOrderText: 2,
        colOrderImage: 1,
        bgClass: 'bg-neon-blue',
        html: 
          '<div>' + 
          '  <h5>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua</h5>' + 
          '</div>'
      },
      organizeDocs: { 
        header: 'Automatically Organize Documents',
        headerIcon: '',
        id: 'documents',
        image: 'trinapp-documents.png',
        colOrderText: 1,
        colOrderImage: 2,
        bgClass: 'bg-light-grad',
        html: 
          '<div>' + 
          '  <h5>Organize documents in TrinPods&trade; representing the Business, Building, or Project they are related to.</h5>' + 
          '</div>'
      },*/
      documentsCTA: {
        header: 'For more information',
        bgClass: 'bg-neon-blue-grad',
        btnText: 'Contact us',
        btnVariant: 'turquoise'
      }
    }
  }
}
</script>